<div class="ca-spinner" [class.ca-spinner--transparent]="transparent()" [class.p-0]="!isText()">
    <div class="ca-spinner__indicator" [style.width.px]="diameter()" [style.height.px]="diameter()">
        <mat-spinner class="spinner-track" mode="determinate" value="100" [diameter]="diameter()"></mat-spinner>
        <mat-spinner [diameter]="diameter()"></mat-spinner>
    </div>

    @if (isText()) {
        <div class="ca-spinner__content" [class.ca-spinner__content--small]="small()">
            @if (text(); as text) {
                <div class="ca-spinner__text">
                    {{ text }}
                </div>
            }
            @if (subtext(); as subtext) {
                <div class="ca-spinner__subtext">
                    {{ subtext }}
                </div>
            }
        </div>
    }
</div>
